import { render, staticRenderFns } from "./dm-detail-fenshen.vue?vue&type=template&id=a17a3afe&scoped=true"
import script from "./dm-detail-fenshen.vue?vue&type=script&lang=js"
export * from "./dm-detail-fenshen.vue?vue&type=script&lang=js"
import style0 from "./dm-detail-fenshen.vue?vue&type=style&index=0&id=a17a3afe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17a3afe",
  null
  
)

export default component.exports